import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteList from './InfiniteList';
import Modal from './Modal';
import NotificationsListItem from './NotificationsListItem';
import axios from '../lib/axios';
import qs from 'qs';

export default class NotificationsList extends Component {
  static propTypes = {
    apiUrl: PropTypes.string.isRequired,
    clicksUrl: PropTypes.string.isRequired,
    linkClicksUrl: PropTypes.string.isRequired,
    viewsUrl: PropTypes.string.isRequired,
    settingsUrl: PropTypes.string.isRequired,
    perPage: PropTypes.number,
    loadingMessage: PropTypes.string,
    noResultsMessage: PropTypes.string,
    reachedEndMessage: PropTypes.string,
  }

  static defaultProps = {
    perPage: 10,
    loadingMessage: 'Loading',
    noResultsMessage: 'There are no notifications to show',
    reachedEndMessage: 'There are no more notifications to show',
  }

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      showModal: false,
      modalUrl: null,
      currentPage: 0,
      loading: false,
      reachedEnd: false,
    };
  }

  componentDidMount() {
    $(this.handleLoad);
    $(document).on('notifications-mark-all-as-read', () => {
      axios.post(this.props.clicksUrl, { ids: this.state.items.map((item) => item.id) })
        .then(() => {
          this.setState(
            {
              items: this.state.items.map((item) => Object.assign({}, item, { read: true })),
            }
          );
        });
    });
  }

  componentWillUnmount() {
    $(document).off('notifications-mark-all-as-read');
  }

  handleLoad = (callback) => {
    const params = qs.parse(window.location.search.slice(1));
    Object.assign(params, { page: this.state.currentPage + 1, perPage: this.props.perPage });

    this.setState({ loading: true });

    this.request = axios.get(this.props.apiUrl, { params })
      .then((response) => {
        this.setState(
          {
            reachedEnd: response.data.length < this.props.perPage,
            loading: false,
            items: this.state.items.concat(response.data),
            currentPage: this.state.currentPage + 1,
          },
          callback
        );
        axios.post(this.props.viewsUrl, { ids: response.data.map((item) => item.id) });
      });
  };

  handleNotificationMarkAsRead(item) {
    axios
      .post(this.props.clicksUrl, { ids: [item.id] })
      .then(() => {
        this.setState(
          {
            items: this.state.items.map((i) => {
              return i.id === item.id ? Object.assign({}, i, { read: true }) : i;
            }),
          }
        );
      });
  }

  handleNotificationClick(e, item) {
    this.handleNotificationMarkAsRead(item);
    if (item.isAnnouncement) {
      e.preventDefault();
      $(document).trigger('announcement-click', item);
      $(document).trigger('announcement-menu', false);
    } else if (item.isModalTrigger) {
      e.preventDefault();
      this.handleModalOpen(item.linkUrl);
    }
  };

  handleModalOpen = (url) => {
    this.setState({showModal: true, modalUrl: url});
  }

  handleModalClose = () => {
    this.setState({showModal: false, modalUrl: null});
  };

  renderItem = (index, key) => {
    const item = this.state.items[index];
    return (
      <NotificationsListItem {...item} key={`item-${key}`} onClick={(e) => this.handleNotificationClick(e, item)} onMarkAsRead={() => this.handleNotificationMarkAsRead(item)} />
    );
  };

  render() {
    const reachedEndMessage = this.state.currentPage > 1 ? this.props.reachedEndMessage : '';
    if (this.state.items.length > 0) {
      return (
        <div>
          <InfiniteList
            {...this.props}
            noResultsMessage={
              this.state.loading ? this.props.loadingMessage : this.props.noResultsMessage
            }
            reachedEndMessage={reachedEndMessage}
            onLoad={this.handleLoad}
            length={this.state.items.length}
            reachedEnd={this.state.reachedEnd}
            itemRenderer={this.renderItem}
          />
          {this.state.showModal && <Modal modalWrapperClassName="compact" visible async asyncUrl={this.state.modalUrl} onClose={this.handleModalClose} />}
        </div>
      );
    } else {
      return (
        <div
          className="u-flex u-justify-center u-py-4"
        >
          { this.state.loading ? 'Loading' : this.props.noResultsMessage}
        </div>
      );
    }
  }
}
